<template>
  <el-collapse-item name="modules">
    <template v-slot:title>
      <span class="collapse-title">
        模块列表({{moduleArray.length}})
        <i class="header-icon el-icon-info"></i>
      </span>
    </template>
    <div v-for="(module) in moduleArray" :key="module.id" style="margin-bottom: 10px;">
      <div class="tip">
        <p>{{module.name+"_"+module.version}}</p>
      </div>
      <el-table :data="module.configList" border>
        <el-table-column align="center" label="模版名称" prop="name"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" label="版本号" prop="version">
        </el-table-column>
        <!-- <el-table-column :show-overflow-tooltip="true" align="center" label="相对路径">
          <template v-slot="{row}">{{row.path}}</template>
        </el-table-column> -->
        <el-table-column align="center" label="操作">
          <template v-slot="{row}">
              <el-button size="mini" type="primary" v-if="!row.isDefault" @click="setDefault(row)">默认</el-button>
              <el-button size="mini" type="primary" v-if="row.isDefault" @click="setDefault(row)">取消默认</el-button>
              <el-button size="mini" type="primary">查看</el-button>
              <el-button size="mini" type="primary" v-if="!row.isDefault">下载</el-button>
              <el-button size="mini" type="primary" v-if="!row.isDefault">上传</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-collapse-item>
</template>

<script>
export default {
  name: "ModulesList",
  inheritAttrs: false,
  props: {
    unit: {
        type: Object,
        required: true,
        default: {}
    }
  },
  
  data: vm => ({
    moduleArray: []
  }),
  created(){
      console.log(this.unit.id)
      this.unit.id ? this.getModuleArray() : true
  },
  methods: {
    getModuleArray(){
        
        this.moduleArray = [
            {
                name: 'test',
                version: '1.1.1',
                configList: [
                    {
                        name: 'xxx.xml',
                        version: '1.0.1',
                        isDefault: true, //是否默认
                    }
                ]
            }
        ]
    },
    setDefault(row){
        row.isDefault = !row.isDefault
    },
  }
};
</script>

<style scoped>
.collapse-title {
  flex: 1 1 auto;
  order: 1;
}
.tip {
    padding: 1px 4px;
    background-color: #ecf8ff;
    border-radius: 4px;
    border-left: 5px solid #50bfff;
    text-align: center;
}
</style>